// ::s.s. RaXna-Edge — build-time plant UI selector (VITE_EDGE_PLANT)
// Allowed: spectrum | bolognini1 | collesecco | cci
// cci = shared RaXna-Edge-CCI cloud SPA (plant id from /api/version)
// last rev:: 2026-09-06

const plant = import.meta.env.VITE_EDGE_PLANT;

if (plant === 'bolognini1' || plant === 'cci') {
  // ::s.s. CCI flotta template = shell Bolognini (PIN ON · /api/cci)
  void import('./plants/bolognini1/bootstrap');
} else if (plant === 'spectrum') {
  void import('./plants/spectrum/bootstrap');
} else if (plant === 'collesecco') {
  void import('./plants/collesecco/bootstrap');
} else {
  throw new Error(
    `::s.s. RaXna-Edge · unknown VITE_EDGE_PLANT=${String(plant)} — set spectrum|bolognini1|collesecco|cci at build time`,
  );
}
